export const rvTable = `<!DOCTYPE html>
<html lang="en">
  <head> </head>
  <body>
    <noscript>You need to enable JavaScript to run this app.</noscript>
    <div id="cssroot"></div>
    <div id="load_extra_css"></div>
    <div id="root">
      <div>
        <nav
          id="topNav"
          class="app_navbar top-navbar"
          style="position: sticky; justify-content: flex-end"
        >
          <div class="app_navbar_logo_wrap">
            <div class="zinologo"></div>
            <div class="mobileview_top_menu">
              <div title="Open menu" class="nav_icon_outer">
                <svg
                  width="22px"
                  height="22px"
                  fill="#667085"
                  version="1.1"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect height="4" rx="2" width="22" x="1" y="2"></rect>
                  <rect height="4" rx="2" width="22" x="1" y="18"></rect>
                  <rect height="4" rx="2" width="22" x="1" y="10"></rect>
                </svg>
              </div>
            </div>
          </div>
          <div
            class="nav_menu_alignment"
            style="width: auto; margin-left: auto"
          >
            <div class="top_menu_outerBox desktopview_top_menu">
              <a class="navbar_menu_item" href="./index.html">
                <div class="navbar_menu_text">Basic</div>
              </a>
              <a
                aria-current="page"
                class="navbar_menu_item menu_item_page_active"
                href="./rvTable.html"
              >
                <div class="navbar_menu_text">Blocks</div>
              </a>
            </div>
            <div class="navbar_icon_container">
              <div></div>
              <div class="navbar_icon_wrap">
                <div title="Open notifications" class="nav_icon_outer">
                  <span
                    class="nav_icon_count nav_icon_style"
                    style="display: none"
                    >0</span
                  >
                  <svg
                    width="22px"
                    height="22px"
                    fill="var(--nav-item-color)"
                    version="1.1"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        d="M5.33301 25.3332V22.6665H7.99967V13.3332C7.99967 11.4887 8.55523 9.84984 9.66634 8.4165C10.7775 6.98317 12.2219 6.04428 13.9997 5.59984V4.6665C13.9997 4.11095 14.1941 3.63873 14.583 3.24984C14.9719 2.86095 15.4441 2.6665 15.9997 2.6665C16.5552 2.6665 17.0275 2.86095 17.4163 3.24984C17.8052 3.63873 17.9997 4.11095 17.9997 4.6665V5.59984C19.7775 6.04428 21.2219 6.98317 22.333 8.4165C23.4441 9.84984 23.9997 11.4887 23.9997 13.3332V22.6665H26.6663V25.3332H5.33301ZM15.9997 29.3332C15.2663 29.3332 14.6386 29.0721 14.1163 28.5498C13.5941 28.0276 13.333 27.3998 13.333 26.6665H18.6663C18.6663 27.3998 18.4052 28.0276 17.883 28.5498C17.3608 29.0721 16.733 29.3332 15.9997 29.3332ZM10.6663 22.6665H21.333V13.3332C21.333 11.8665 20.8108 10.6109 19.7663 9.5665C18.7219 8.52206 17.4663 7.99984 15.9997 7.99984C14.533 7.99984 13.2775 8.52206 12.233 9.5665C11.1886 10.6109 10.6663 11.8665 10.6663 13.3332V22.6665Z"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div title="Chat">
                <div class="navbar_icon_wrap">
                  <div class="nav_icon_outer">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="#667085"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 20l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 11H6v-2h12v2zm0-3H6V8h12v2z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="profile_dropdown_container">
                <div class="profile_dropdown">
                  <div title="Open profile" class="nav_icon_outer">
                    <div class="navbar_user_avatar one-letter">P</div>
                  </div>
                  <div class="profile_popover">
                    <div title="Prajwal"><span>Prajwal</span></div>
                    <div title="prajwal.bu@getzino.com">
                      <span>prajwal.bu@getzino.com</span>
                    </div>
                    <div class="cursor-pointer"><span>Apps List</span></div>
                    <div class="cursor-pointer">
                      <span>Change Password</span>
                    </div>
                    <div class="cursor-pointer"><span>Log out</span></div>
                    <div><span>Version : 0.0.602</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div class="body" class="body">
          <div class="center-page">
            <div class="all-blocks-wrap">
              <div
                class="section"
                style="height: 720px; position: relative; min-height: 1117px"
              >
                <div
                  class="block-recordsview"
                  style="
                    height: 708px;
                    left: 36px;
                    position: absolute;
                    top: 12px;
                    width: 1536px;
                    min-height: 1105px;
                  "
                >
                  <div
                    class="section"
                    style="
                      height: 1100px;
                      position: relative;
                      min-height: 1105px;
                    "
                  >
                    <div
                      class="rv-container z-table-stripped"
                      style="
                        height: 629px;
                        left: 36px;
                        position: absolute;
                        top: 476px;
                        width: 1544px;
                      "
                    >
                      <div class="rv-table-wrap">
                        <table class="recordview_table">
                          <thead>
                            <tr>
                              <th class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Textfield</span>
                                </div>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Email</span>
                                </div>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Date</span>
                                </div>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Select Chips</span>
                                </div>
                              </th>
                              <th align="left">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>custom</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        santosh
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    S
                                  </div>
                                  <span>santosh@gmail.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >12-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        hiran
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    H
                                  </div>
                                  <span>hiran@gmail.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >05-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        krishna
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    K
                                  </div>
                                  <span>krishna5678@gmaol.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >07-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        prajwal
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    J
                                  </div>
                                  <span>jayanth@gmaol.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >05-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        Jayanth
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    R
                                  </div>
                                  <span>raju777@gmail.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >07-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td class="table_checkbox">
                                <span
                                  ><svg
                                    width="20px"
                                    height="20px"
                                    version="1.1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_101_23)">
                                      <rect
                                        x="1"
                                        y="1"
                                        width="22"
                                        height="22"
                                        rx="3"
                                        fill=""
                                        stroke="#767676"
                                        stroke-width="2"
                                      ></rect>
                                    </g>
                                    <defs>
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      ></rect>
                                    </defs></svg
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span
                                    ><div style="display: flex; gap: 6px">
                                      <div class="chip-element z-default-text">
                                        raja
                                      </div>
                                    </div></span
                                  ></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_2">
                                  <div
                                    class="field_avatar"
                                    style="background-color: rgb(102, 112, 133)"
                                  >
                                    R
                                  </div>
                                  <span>raja@example.com</span>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span class="d_flex gap_3"
                                    >11-Feb-2025</span
                                  ></span
                                >
                              </td>
                              <td style="width: auto"></td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline z-btn-small element-button z-btn-primary z-btn"
                                  >
                                    view
                                  </button>
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Item List</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                  <button
                                    class="element-button z-btn-primary z-btn"
                                  >
                                    Button
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="z-rv-footer">
                        <div class="gap_3">
                          <div
                            class="recordview_filter_dropDown_outerBox w_fit"
                            style="padding: 8px; min-width: 0px"
                          >
                            <span class="recordview_filter_field_exp"
                              ><span>10</span>
                              <svg
                                class="expand_arrow_icon"
                                width="16px"
                                height="16px"
                                fill="#fff"
                                version="1.1"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.285,11.284L16,19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429,0  c-0.394,0.395-0.394,1.035,0,1.43l8.999,9.002l0,0l0,0c0.394,0.395,1.034,0.395,1.428,0l8.999-9.002  c0.394-0.395,0.394-1.036,0-1.431C25.319,10.889,24.679,10.889,24.285,11.284z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <p class="app_label">1-6 of 6</p>
                        </div>
                        <div class="gap_3">
                          <button class="zino_btn_disabled arrow_btn">
                            <svg
                              width="20px"
                              height="20px"
                              viewBox="0 0 32 32"
                              fill="#667085"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                clip-rule="evenodd"
                                d="M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z"
                              ></path>
                            </svg>
                          </button>
                          <div
                            class="recordview_filter_dropDown_outerBox"
                            style="padding: 8px; min-width: 0px"
                          >
                            <span class="recordview_filter_field_exp"
                              ><span>1</span>
                              <svg
                                class="expand_arrow_icon"
                                width="16px"
                                height="16px"
                                fill="#fff"
                                version="1.1"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.285,11.284L16,19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429,0  c-0.394,0.395-0.394,1.035,0,1.43l8.999,9.002l0,0l0,0c0.394,0.395,1.034,0.395,1.428,0l8.999-9.002  c0.394-0.395,0.394-1.036,0-1.431C25.319,10.889,24.679,10.889,24.285,11.284z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <button
                            class="zino_btn_outline_secondary zino_btn_disabled arrow_btn"
                          >
                            <svg
                              width="20px"
                              height="20px"
                              viewBox="0 0 32 32"
                              fill="#667085"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                clip-rule="evenodd"
                                d="M21.698,15.286l-9.002-8.999  c-0.395-0.394-1.035-0.394-1.431,0c-0.395,0.394-0.395,1.034,0,1.428L19.553,16l-8.287,8.285c-0.395,0.394-0.395,1.034,0,1.429  c0.395,0.394,1.036,0.394,1.431,0l9.002-8.999C22.088,16.325,22.088,15.675,21.698,15.286z"
                                fill-rule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      class="element-button z-btn zino_btn_disabled"
                      style="
                        left: 1404px;
                        position: absolute;
                        top: 492px;
                        width: 150px;
                      "
                    >
                      Button
                    </button>
                    <div
                      class="z-rv-chart"
                      style="
                        height: 300px;
                        left: 900px;
                        position: absolute;
                        top: 72px;
                        width: 600px;
                      "
                    >
                      <div
                        options="[object Object]"
                        series="[object Object]"
                        type="line"
                        height="100%"
                        width="100%"
                        class=""
                      >
                        <div
                          id="apexchartsv6pyum9n"
                          class="apexcharts-canvas apexchartsv6pyum9n apexcharts-theme-"
                          style="width: 558px; height: 258px"
                        >
                          <svg
                            id="SvgjsSvg1006"
                            width="558"
                            height="258"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.dev"
                            class="apexcharts-svg"
                            xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                          >
                            <foreignObject x="0" y="0" width="558" height="258">
                              <div
                                class="apexcharts-legend apexcharts-align-center apx-legend-position-right"
                                xmlns="http://www.w3.org/1999/xhtml"
                                style="
                                  position: absolute;
                                  left: auto;
                                  top: 24px;
                                  right: 5px;
                                "
                              >
                                <div
                                  class="apexcharts-legend-series"
                                  rel="1"
                                  seriesname=""
                                  data:collapsed="false"
                                  style="margin: 3px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="1"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1011"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1012"
                                        ><clipPath id="gridRectMaskv6pyum9n"
                                          ><rect
                                            id="SvgjsRect1018"
                                            width="354.525390625"
                                            height="164.348"
                                            x="0"
                                            y="0"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath id="gridRectBarMaskv6pyum9n"
                                          ><rect
                                            id="SvgjsRect1019"
                                            width="360.525390625"
                                            height="170.348"
                                            x="-3"
                                            y="-3"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="gridRectMarkerMaskv6pyum9n"
                                          ><rect
                                            id="SvgjsRect1020"
                                            width="370.525390625"
                                            height="180.348"
                                            x="-8"
                                            y="-8"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="forecastMaskv6pyum9n"
                                        ></clipPath
                                        ><clipPath
                                          id="nonForecastMaskv6pyum9n"
                                        ></clipPath></defs
                                      ><path
                                        id="SvgjsPath1013"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="1"
                                    i="0"
                                    data:default-text="%2C%20-%20%2C1%2C1%2C1%2C1%2C1%2C1"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    - 1,1,1,1,1,1</span
                                  >
                                </div>
                              </div>
                              <style type="text/css">
                                .apexcharts-flip-y {
                                  transform: scaleY(-1) translateY(-100%);
                                  transform-origin: top;
                                  transform-box: fill-box;
                                }
                                .apexcharts-flip-x {
                                  transform: scaleX(-1);
                                  transform-origin: center;
                                  transform-box: fill-box;
                                }
                                .apexcharts-legend {
                                  display: flex;
                                  overflow: auto;
                                  padding: 0 10px;
                                }
                                .apexcharts-legend.apx-legend-position-bottom,
                                .apexcharts-legend.apx-legend-position-top {
                                  flex-wrap: wrap;
                                }
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  flex-direction: column;
                                  bottom: 0;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  justify-content: flex-start;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
                                  justify-content: center;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
                                  justify-content: flex-end;
                                }
                                .apexcharts-legend-series {
                                  cursor: pointer;
                                  line-height: normal;
                                  display: flex;
                                  align-items: center;
                                }
                                .apexcharts-legend-text {
                                  position: relative;
                                  font-size: 14px;
                                }
                                .apexcharts-legend-text *,
                                .apexcharts-legend-marker * {
                                  pointer-events: none;
                                }
                                .apexcharts-legend-marker {
                                  position: relative;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  cursor: pointer;
                                  margin-right: 1px;
                                }

                                .apexcharts-legend-series.apexcharts-no-click {
                                  cursor: auto;
                                }
                                .apexcharts-legend
                                  .apexcharts-hidden-zero-series,
                                .apexcharts-legend
                                  .apexcharts-hidden-null-series {
                                  display: none !important;
                                }
                                .apexcharts-inactive-legend {
                                  opacity: 0.45;
                                }
                              </style>
                            </foreignObject>
                            <text
                              id="SvgjsText1009"
                              font-family="Helvetica, Arial, sans-serif"
                              x="279"
                              y="16.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="14px"
                              font-weight="900"
                              fill="#373d3f"
                              class="apexcharts-title-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            >
                              New Chart
                            </text>
                            <text
                              id="SvgjsText1010"
                              font-family="Helvetica, Arial, sans-serif"
                              x="279"
                              y="44.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="12px"
                              font-weight="400"
                              fill="#373d3f"
                              class="apexcharts-subtitle-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            ></text>
                            <g
                              id="SvgjsG1021"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                            <g
                              id="SvgjsG1022"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                            <g
                              id="SvgjsG1085"
                              class="apexcharts-yaxis"
                              rel="0"
                              transform="translate(12.296875, 0)"
                            >
                              <g
                                id="SvgjsG1086"
                                class="apexcharts-yaxis-texts-g"
                              >
                                <text
                                  id="SvgjsText1088"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="62.666666666666664"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1089">2</tspan>
                                  <title>2</title>
                                </text>
                                <text
                                  id="SvgjsText1091"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="103.75366666666667"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1092">1.5</tspan>
                                  <title>1.5</title>
                                </text>
                                <text
                                  id="SvgjsText1094"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="144.84066666666666"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1095">1</tspan>
                                  <title>1</title>
                                </text>
                                <text
                                  id="SvgjsText1097"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="185.92766666666665"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1098">0.5</tspan>
                                  <title>0.5</title>
                                </text>
                                <text
                                  id="SvgjsText1100"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="227.01466666666664"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1101">0</tspan>
                                  <title>0</title>
                                </text>
                              </g>
                              <g id="SvgjsG1102" class="apexcharts-yaxis-title">
                                <text
                                  id="SvgjsText1103"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="-10.296875"
                                  y="141.174"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="900"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-title-text"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                  transform="rotate(-90 0 0)"
                                ></text>
                              </g>
                            </g>
                            <g
                              id="SvgjsG1008"
                              class="apexcharts-inner apexcharts-graphical"
                              transform="translate(42.296875, 59)"
                            >
                              <defs id="SvgjsDefs1007"></defs>
                              <line
                                id="SvgjsLine1043"
                                x1="0"
                                y1="164.348"
                                x2="0"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1044"
                                x1="70.905078125"
                                y1="164.348"
                                x2="70.905078125"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1045"
                                x1="141.81015625"
                                y1="164.348"
                                x2="141.81015625"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1046"
                                x1="212.71523437500002"
                                y1="164.348"
                                x2="212.71523437500002"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1047"
                                x1="283.6203125"
                                y1="164.348"
                                x2="283.6203125"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1048"
                                x1="354.525390625"
                                y1="164.348"
                                x2="354.525390625"
                                y2="170.348"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <g id="SvgjsG1039" class="apexcharts-grid">
                                <g
                                  id="SvgjsG1040"
                                  class="apexcharts-gridlines-horizontal"
                                >
                                  <line
                                    id="SvgjsLine1050"
                                    x1="0"
                                    y1="41.087"
                                    x2="354.525390625"
                                    y2="41.087"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                  <line
                                    id="SvgjsLine1051"
                                    x1="0"
                                    y1="82.174"
                                    x2="354.525390625"
                                    y2="82.174"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                  <line
                                    id="SvgjsLine1052"
                                    x1="0"
                                    y1="123.26100000000001"
                                    x2="354.525390625"
                                    y2="123.26100000000001"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                </g>
                                <g
                                  id="SvgjsG1041"
                                  class="apexcharts-gridlines-vertical"
                                ></g>
                                <rect
                                  id="SvgjsRect1054"
                                  width="354.525390625"
                                  height="41.087"
                                  x="0"
                                  y="0"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="#f3f3f3"
                                  clip-path="url(#gridRectMaskv6pyum9n)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1055"
                                  width="354.525390625"
                                  height="41.087"
                                  x="0"
                                  y="41.087"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="transparent"
                                  clip-path="url(#gridRectMaskv6pyum9n)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1056"
                                  width="354.525390625"
                                  height="41.087"
                                  x="0"
                                  y="82.174"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="#f3f3f3"
                                  clip-path="url(#gridRectMaskv6pyum9n)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1057"
                                  width="354.525390625"
                                  height="41.087"
                                  x="0"
                                  y="123.26100000000001"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="transparent"
                                  clip-path="url(#gridRectMaskv6pyum9n)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <line
                                  id="SvgjsLine1059"
                                  x1="0"
                                  y1="164.348"
                                  x2="354.525390625"
                                  y2="164.348"
                                  stroke="transparent"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                ></line>
                                <line
                                  id="SvgjsLine1058"
                                  x1="0"
                                  y1="1"
                                  x2="0"
                                  y2="164.348"
                                  stroke="transparent"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                ></line>
                              </g>
                              <g
                                id="SvgjsG1042"
                                class="apexcharts-grid-borders"
                              >
                                <line
                                  id="SvgjsLine1049"
                                  x1="0"
                                  y1="0"
                                  x2="354.525390625"
                                  y2="0"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                  class="apexcharts-gridline"
                                ></line>
                                <line
                                  id="SvgjsLine1053"
                                  x1="0"
                                  y1="164.348"
                                  x2="354.525390625"
                                  y2="164.348"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                  class="apexcharts-gridline"
                                ></line>
                                <line
                                  id="SvgjsLine1084"
                                  x1="0"
                                  y1="164.348"
                                  x2="354.525390625"
                                  y2="164.348"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-width="1"
                                  stroke-linecap="butt"
                                ></line>
                              </g>
                              <g
                                id="SvgjsG1023"
                                class="apexcharts-line-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1024"
                                  class="apexcharts-series"
                                  zindex="0"
                                  seriesname=""
                                  data:longestseries="true"
                                  rel="1"
                                  data:realindex="0"
                                >
                                  <path
                                    id="SvgjsPath1038"
                                    d="M0 82.174L70.905078125 82.174L141.81015625 82.174L212.715234375 82.174L283.6203125 82.174L354.525390625 82.174C354.525390625 82.174 354.525390625 82.174 354.525390625 82.174 "
                                    fill="none"
                                    fill-opacity="1"
                                    stroke="rgba(0,143,251,0.85)"
                                    stroke-opacity="1"
                                    stroke-linecap="butt"
                                    stroke-width="2"
                                    stroke-dasharray="0"
                                    class="apexcharts-line"
                                    index="0"
                                    clip-path="url(#gridRectMaskv6pyum9n)"
                                    pathto="M 0 82.174 L 70.905078125 82.174 L 141.81015625 82.174 L 212.715234375 82.174 L 283.6203125 82.174 L 354.525390625 82.174"
                                    pathfrom="M 0 164.348 L 0 164.348 L 70.905078125 164.348 L 141.81015625 164.348 L 212.715234375 164.348 L 283.6203125 164.348 L 354.525390625 164.348"
                                    fill-rule="evenodd"
                                  ></path>
                                  <g
                                    id="SvgjsG1025"
                                    class="apexcharts-series-markers-wrap apexcharts-hidden-element-shown"
                                    data:realindex="0"
                                  >
                                    <g
                                      id="SvgjsG1027"
                                      class="apexcharts-series-markers"
                                      clip-path="url(#gridRectMarkerMaskv6pyum9n)"
                                    >
                                      <path
                                        id="SvgjsPath1028"
                                        d="M 0, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events wtml8uuwx"
                                        rel="0"
                                        j="0"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                      <path
                                        id="SvgjsPath1029"
                                        d="M 70.905078125, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="70.905078125"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events wrrrpcvjx"
                                        rel="1"
                                        j="1"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1030"
                                      class="apexcharts-series-markers"
                                      clip-path="url(#gridRectMarkerMaskv6pyum9n)"
                                    >
                                      <path
                                        id="SvgjsPath1031"
                                        d="M 141.81015625, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="141.81015625"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events wlez313n7"
                                        rel="2"
                                        j="2"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1032"
                                      class="apexcharts-series-markers"
                                      clip-path="url(#gridRectMarkerMaskv6pyum9n)"
                                    >
                                      <path
                                        id="SvgjsPath1033"
                                        d="M 212.715234375, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="212.715234375"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events woyjabclw"
                                        rel="3"
                                        j="3"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1034"
                                      class="apexcharts-series-markers"
                                      clip-path="url(#gridRectMarkerMaskv6pyum9n)"
                                    >
                                      <path
                                        id="SvgjsPath1035"
                                        d="M 283.6203125, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="283.6203125"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events w8pcvlnnj"
                                        rel="4"
                                        j="4"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1036"
                                      class="apexcharts-series-markers"
                                      clip-path="url(#gridRectMarkerMaskv6pyum9n)"
                                    >
                                      <path
                                        id="SvgjsPath1037"
                                        d="M 354.525390625, 82.174 
           m -4, 0 
           a 4,4 0 1,0 8,0 
           a 4,4 0 1,0 -8,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        cx="354.525390625"
                                        cy="82.174"
                                        shape="circle"
                                        class="apexcharts-marker no-pointer-events wh0sh0dx6"
                                        rel="5"
                                        j="5"
                                        index="0"
                                        default-marker-size="4"
                                      ></path>
                                    </g>
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1026"
                                  class="apexcharts-datalabels"
                                  data:realindex="0"
                                ></g>
                              </g>
                              <line
                                id="SvgjsLine1060"
                                x1="0"
                                y1="0"
                                x2="354.525390625"
                                y2="0"
                                stroke="#b6b6b6"
                                stroke-dasharray="0"
                                stroke-width="1"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs"
                              ></line>
                              <line
                                id="SvgjsLine1061"
                                x1="0"
                                y1="0"
                                x2="354.525390625"
                                y2="0"
                                stroke-dasharray="0"
                                stroke-width="0"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs-hidden"
                              ></line>
                              <g
                                id="SvgjsG1062"
                                class="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1063"
                                  class="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -4)"
                                >
                                  <text
                                    id="SvgjsText1065"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="0"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1066">Jayanth</tspan>
                                    <title>Jayanth</title>
                                  </text>
                                  <text
                                    id="SvgjsText1068"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="70.90507812500002"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1069">hiran</tspan>
                                    <title>hiran</title>
                                  </text>
                                  <text
                                    id="SvgjsText1071"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="141.81015625"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1072">krishna</tspan>
                                    <title>krishna</title>
                                  </text>
                                  <text
                                    id="SvgjsText1074"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="212.715234375"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1075">prajwal</tspan>
                                    <title>prajwal</title>
                                  </text>
                                  <text
                                    id="SvgjsText1077"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="283.62031249999995"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1078">raja</tspan>
                                    <title>raja</title>
                                  </text>
                                  <text
                                    id="SvgjsText1080"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="354.52539062499994"
                                    y="192.348"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  >
                                    <tspan id="SvgjsTspan1081">santosh</tspan>
                                    <title>santosh</title>
                                  </text>
                                </g>
                                <g
                                  id="SvgjsG1082"
                                  class="apexcharts-xaxis-title"
                                >
                                  <text
                                    id="SvgjsText1083"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="177.2626953125"
                                    y="209"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="900"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-title-text"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  ></text>
                                </g>
                              </g>
                              <g
                                id="SvgjsG1104"
                                class="apexcharts-yaxis-annotations apexcharts-hidden-element-shown"
                              ></g>
                              <g
                                id="SvgjsG1105"
                                class="apexcharts-xaxis-annotations apexcharts-hidden-element-shown"
                              ></g>
                              <g
                                id="SvgjsG1106"
                                class="apexcharts-point-annotations apexcharts-hidden-element-shown"
                              ></g>
                            </g>
                          </svg>
                          <div
                            class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light"
                          >
                            <div class="apexcharts-yaxistooltip-text"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="z-rv-chart"
                      style="
                        height: 360px;
                        left: 36px;
                        position: absolute;
                        top: 60px;
                        width: 348px;
                      "
                    >
                      <div
                        options="[object Object]"
                        series="[object Object]"
                        type="bar"
                        height="100%"
                        width="100%"
                      >
                        <div
                          id="apexcharts1peudthz"
                          class="apexcharts-canvas apexcharts1peudthz apexcharts-theme-"
                          style="width: 306px; height: 318px"
                        >
                          <svg
                            id="SvgjsSvg1107"
                            width="306"
                            height="318"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.dev"
                            class="apexcharts-svg"
                            xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                          >
                            <foreignObject x="0" y="0" width="306" height="318">
                              <div
                                class="apexcharts-legend apexcharts-align-center apx-legend-position-bottom"
                                xmlns="http://www.w3.org/1999/xhtml"
                                style="
                                  right: 0px;
                                  position: absolute;
                                  left: 0px;
                                  top: 293px;
                                  max-height: 159px;
                                "
                              >
                                <div
                                  class="apexcharts-legend-series"
                                  rel="1"
                                  seriesname=""
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="1"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1112"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1113"
                                        ><clipPath id="gridRectMask1peudthz"
                                          ><rect
                                            id="SvgjsRect1120"
                                            width="253.703125"
                                            height="160.01581803385417"
                                            x="0"
                                            y="0"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath id="gridRectBarMask1peudthz"
                                          ><rect
                                            id="SvgjsRect1121"
                                            width="259.703125"
                                            height="166.01581803385417"
                                            x="-3"
                                            y="-3"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="gridRectMarkerMask1peudthz"
                                          ><rect
                                            id="SvgjsRect1122"
                                            width="269.703125"
                                            height="176.01581803385417"
                                            x="-8"
                                            y="-8"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="forecastMask1peudthz"
                                        ></clipPath
                                        ><clipPath
                                          id="nonForecastMask1peudthz"
                                        ></clipPath></defs
                                      ><path
                                        id="SvgjsPath1114"
                                        d="M -6.222222222222222 -6.222222222222222 
           L 6.222222222222222 -6.222222222222222 
           L 6.222222222222222 6.222222222222222 
           L -6.222222222222222 6.222222222222222 
           Z"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="round"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="square"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-square"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="1"
                                    i="0"
                                    data:default-text=""
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  ></span>
                                </div>
                              </div>
                              <style type="text/css">
                                .apexcharts-flip-y {
                                  transform: scaleY(-1) translateY(-100%);
                                  transform-origin: top;
                                  transform-box: fill-box;
                                }
                                .apexcharts-flip-x {
                                  transform: scaleX(-1);
                                  transform-origin: center;
                                  transform-box: fill-box;
                                }
                                .apexcharts-legend {
                                  display: flex;
                                  overflow: auto;
                                  padding: 0 10px;
                                }
                                .apexcharts-legend.apx-legend-position-bottom,
                                .apexcharts-legend.apx-legend-position-top {
                                  flex-wrap: wrap;
                                }
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  flex-direction: column;
                                  bottom: 0;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  justify-content: flex-start;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
                                  justify-content: center;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
                                  justify-content: flex-end;
                                }
                                .apexcharts-legend-series {
                                  cursor: pointer;
                                  line-height: normal;
                                  display: flex;
                                  align-items: center;
                                }
                                .apexcharts-legend-text {
                                  position: relative;
                                  font-size: 14px;
                                }
                                .apexcharts-legend-text *,
                                .apexcharts-legend-marker * {
                                  pointer-events: none;
                                }
                                .apexcharts-legend-marker {
                                  position: relative;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  cursor: pointer;
                                  margin-right: 1px;
                                }

                                .apexcharts-legend-series.apexcharts-no-click {
                                  cursor: auto;
                                }
                                .apexcharts-legend
                                  .apexcharts-hidden-zero-series,
                                .apexcharts-legend
                                  .apexcharts-hidden-null-series {
                                  display: none !important;
                                }
                                .apexcharts-inactive-legend {
                                  opacity: 0.45;
                                }
                              </style>
                            </foreignObject>
                            <text
                              id="SvgjsText1110"
                              font-family="Helvetica, Arial, sans-serif"
                              x="153"
                              y="16.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="14px"
                              font-weight="900"
                              fill="#373d3f"
                              class="apexcharts-title-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            >
                              New Chart
                            </text>
                            <text
                              id="SvgjsText1111"
                              font-family="Helvetica, Arial, sans-serif"
                              x="153"
                              y="44.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="12px"
                              font-weight="400"
                              fill="#373d3f"
                              class="apexcharts-subtitle-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            ></text>
                            <g
                              id="SvgjsG1123"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                            <g
                              id="SvgjsG1124"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                            <g
                              id="SvgjsG1191"
                              class="apexcharts-yaxis"
                              rel="0"
                              transform="translate(12.296875, 0)"
                            >
                              <g
                                id="SvgjsG1192"
                                class="apexcharts-yaxis-texts-g"
                              >
                                <text
                                  id="SvgjsText1194"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="62.666666666666664"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1195">1</tspan>
                                  <title>1</title>
                                </text>
                                <text
                                  id="SvgjsText1197"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="94.6698302734375"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1198">0.8</tspan>
                                  <title>0.8</title>
                                </text>
                                <text
                                  id="SvgjsText1200"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="126.67299388020834"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1201">0.6</tspan>
                                  <title>0.6</title>
                                </text>
                                <text
                                  id="SvgjsText1203"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="158.67615748697918"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1204">0.4</tspan>
                                  <title>0.4</title>
                                </text>
                                <text
                                  id="SvgjsText1206"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="190.67932109375002"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1207">0.2</tspan>
                                  <title>0.2</title>
                                </text>
                                <text
                                  id="SvgjsText1209"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="20"
                                  y="222.68248470052086"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="400"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-label"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                >
                                  <tspan id="SvgjsTspan1210">0</tspan>
                                  <title>0</title>
                                </text>
                              </g>
                              <g id="SvgjsG1211" class="apexcharts-yaxis-title">
                                <text
                                  id="SvgjsText1212"
                                  font-family="Helvetica, Arial, sans-serif"
                                  x="-11.173828125"
                                  y="139.0079090169271"
                                  text-anchor="end"
                                  dominant-baseline="auto"
                                  font-size="11px"
                                  font-weight="900"
                                  fill="#373d3f"
                                  class="apexcharts-text apexcharts-yaxis-title-text"
                                  style="
                                    font-family: Helvetica, Arial, sans-serif;
                                  "
                                  transform="rotate(-90 0 0)"
                                ></text>
                              </g>
                            </g>
                            <g
                              id="SvgjsG1109"
                              class="apexcharts-inner apexcharts-graphical"
                              transform="translate(42.296875, 59)"
                            >
                              <defs id="SvgjsDefs1108"></defs>
                              <line
                                id="SvgjsLine1146"
                                x1="0"
                                y1="160.01581803385417"
                                x2="0"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1147"
                                x1="42.283854166666664"
                                y1="160.01581803385417"
                                x2="42.283854166666664"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1148"
                                x1="84.56770833333333"
                                y1="160.01581803385417"
                                x2="84.56770833333333"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1149"
                                x1="126.8515625"
                                y1="160.01581803385417"
                                x2="126.8515625"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1150"
                                x1="169.13541666666666"
                                y1="160.01581803385417"
                                x2="169.13541666666666"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1151"
                                x1="211.41927083333331"
                                y1="160.01581803385417"
                                x2="211.41927083333331"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <line
                                id="SvgjsLine1152"
                                x1="253.70312499999997"
                                y1="160.01581803385417"
                                x2="253.70312499999997"
                                y2="166.01581803385417"
                                stroke="#e0e0e0"
                                stroke-dasharray="0"
                                stroke-linecap="butt"
                                class="apexcharts-xaxis-tick"
                              ></line>
                              <g id="SvgjsG1142" class="apexcharts-grid">
                                <g
                                  id="SvgjsG1143"
                                  class="apexcharts-gridlines-horizontal"
                                >
                                  <line
                                    id="SvgjsLine1154"
                                    x1="0"
                                    y1="32.00316360677083"
                                    x2="253.703125"
                                    y2="32.00316360677083"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                  <line
                                    id="SvgjsLine1155"
                                    x1="0"
                                    y1="64.00632721354167"
                                    x2="253.703125"
                                    y2="64.00632721354167"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                  <line
                                    id="SvgjsLine1156"
                                    x1="0"
                                    y1="96.0094908203125"
                                    x2="253.703125"
                                    y2="96.0094908203125"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                  <line
                                    id="SvgjsLine1157"
                                    x1="0"
                                    y1="128.01265442708333"
                                    x2="253.703125"
                                    y2="128.01265442708333"
                                    stroke="#e0e0e0"
                                    stroke-dasharray="0"
                                    stroke-linecap="butt"
                                    class="apexcharts-gridline"
                                  ></line>
                                </g>
                                <g
                                  id="SvgjsG1144"
                                  class="apexcharts-gridlines-vertical"
                                ></g>
                                <rect
                                  id="SvgjsRect1159"
                                  width="253.703125"
                                  height="32.00316360677083"
                                  x="0"
                                  y="0"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="#f3f3f3"
                                  clip-path="url(#gridRectMask1peudthz)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1160"
                                  width="253.703125"
                                  height="32.00316360677083"
                                  x="0"
                                  y="32.00316360677083"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="transparent"
                                  clip-path="url(#gridRectMask1peudthz)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1161"
                                  width="253.703125"
                                  height="32.00316360677083"
                                  x="0"
                                  y="64.00632721354167"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="#f3f3f3"
                                  clip-path="url(#gridRectMask1peudthz)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1162"
                                  width="253.703125"
                                  height="32.00316360677083"
                                  x="0"
                                  y="96.0094908203125"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="transparent"
                                  clip-path="url(#gridRectMask1peudthz)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <rect
                                  id="SvgjsRect1163"
                                  width="253.703125"
                                  height="32.00316360677083"
                                  x="0"
                                  y="128.01265442708333"
                                  rx="0"
                                  ry="0"
                                  opacity="0.5"
                                  stroke-width="0"
                                  stroke="none"
                                  stroke-dasharray="0"
                                  fill="#f3f3f3"
                                  clip-path="url(#gridRectMask1peudthz)"
                                  class="apexcharts-grid-row"
                                ></rect>
                                <line
                                  id="SvgjsLine1165"
                                  x1="0"
                                  y1="160.01581803385417"
                                  x2="253.703125"
                                  y2="160.01581803385417"
                                  stroke="transparent"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                ></line>
                                <line
                                  id="SvgjsLine1164"
                                  x1="0"
                                  y1="1"
                                  x2="0"
                                  y2="160.01581803385417"
                                  stroke="transparent"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                ></line>
                              </g>
                              <g
                                id="SvgjsG1145"
                                class="apexcharts-grid-borders"
                              >
                                <line
                                  id="SvgjsLine1153"
                                  x1="0"
                                  y1="0"
                                  x2="253.703125"
                                  y2="0"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                  class="apexcharts-gridline"
                                ></line>
                                <line
                                  id="SvgjsLine1158"
                                  x1="0"
                                  y1="160.01581803385417"
                                  x2="253.703125"
                                  y2="160.01581803385417"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-linecap="butt"
                                  class="apexcharts-gridline"
                                ></line>
                                <line
                                  id="SvgjsLine1190"
                                  x1="0"
                                  y1="160.01581803385417"
                                  x2="253.703125"
                                  y2="160.01581803385417"
                                  stroke="#e0e0e0"
                                  stroke-dasharray="0"
                                  stroke-width="1"
                                  stroke-linecap="butt"
                                ></line>
                              </g>
                              <g
                                id="SvgjsG1125"
                                class="apexcharts-bar-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1126"
                                  class="apexcharts-series"
                                  rel="1"
                                  seriesname=""
                                  data:realindex="0"
                                >
                                  <path
                                    id="SvgjsPath1131"
                                    d="M9.513867187499999 160.01681803385418L9.513867187499999 0.0010000000000047748C9.513867187499999 0.0010000000000047748 9.513867187499997 0.0010000000000047748 9.513867187499997 0.0010000000000047748L32.76998697916667 0.0010000000000047748C32.76998697916667 0.0010000000000047748 32.76998697916667 0.0010000000000047748 32.76998697916667 0.0010000000000047748L32.76998697916667 160.01681803385418C32.76998697916667 160.01681803385418 32.76998697916667 160.01681803385418 32.76998697916667 160.01681803385418L9.513867187499999 160.01681803385418C9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418C9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 9.513867187499999 160.01681803385418 L 9.513867187499999 0.001 C 9.513867187499999 0.001 9.513867187499999 0.001 9.513867187499999 0.001 L 32.76998697916667 0.001 C 32.76998697916667 0.001 32.76998697916667 0.001 32.76998697916667 0.001 L 32.76998697916667 160.01681803385418 C 32.76998697916667 160.01681803385418 32.76998697916667 160.01681803385418 32.76998697916667 160.01681803385418 L 9.513867187499999 160.01681803385418 C 9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418 9.513867187499999 160.01681803385418 Z "
                                    pathfrom="M 9.513867187499999 160.01681803385418 L 9.513867187499999 160.01681803385418 L 32.76998697916667 160.01681803385418 L 32.76998697916667 160.01681803385418 L 32.76998697916667 160.01681803385418 L 32.76998697916667 160.01681803385418 L 32.76998697916667 160.01681803385418 L 9.513867187499999 160.01681803385418 Z"
                                    cy="0"
                                    cx="50.79772135416666"
                                    j="0"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <path
                                    id="SvgjsPath1133"
                                    d="M51.79772135416666 160.01681803385418L51.79772135416666 0.0010000000000047748C51.79772135416666 0.0010000000000047748 51.79772135416666 0.0010000000000047748 51.79772135416666 0.0010000000000047748L75.05384114583333 0.0010000000000047748C75.05384114583333 0.0010000000000047748 75.05384114583333 0.0010000000000047748 75.05384114583333 0.0010000000000047748L75.05384114583333 160.01681803385418C75.05384114583333 160.01681803385418 75.05384114583333 160.01681803385418 75.05384114583333 160.01681803385418L51.79772135416666 160.01681803385418C51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418C51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 51.79772135416666 160.01681803385418 L 51.79772135416666 0.001 C 51.79772135416666 0.001 51.79772135416666 0.001 51.79772135416666 0.001 L 75.05384114583333 0.001 C 75.05384114583333 0.001 75.05384114583333 0.001 75.05384114583333 0.001 L 75.05384114583333 160.01681803385418 C 75.05384114583333 160.01681803385418 75.05384114583333 160.01681803385418 75.05384114583333 160.01681803385418 L 51.79772135416666 160.01681803385418 C 51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418 51.79772135416666 160.01681803385418 Z "
                                    pathfrom="M 51.79772135416666 160.01681803385418 L 51.79772135416666 160.01681803385418 L 75.05384114583333 160.01681803385418 L 75.05384114583333 160.01681803385418 L 75.05384114583333 160.01681803385418 L 75.05384114583333 160.01681803385418 L 75.05384114583333 160.01681803385418 L 51.79772135416666 160.01681803385418 Z"
                                    cy="0"
                                    cx="93.08157552083333"
                                    j="1"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <path
                                    id="SvgjsPath1135"
                                    d="M94.08157552083333 160.01681803385418L94.08157552083333 0.0010000000000047748C94.08157552083333 0.0010000000000047748 94.08157552083333 0.0010000000000047748 94.08157552083333 0.0010000000000047748L117.33769531249999 0.0010000000000047748C117.33769531249999 0.0010000000000047748 117.33769531249999 0.0010000000000047748 117.33769531249999 0.0010000000000047748L117.33769531249999 160.01681803385418C117.33769531249999 160.01681803385418 117.33769531249999 160.01681803385418 117.33769531249999 160.01681803385418L94.08157552083333 160.01681803385418C94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418C94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 94.08157552083333 160.01681803385418 L 94.08157552083333 0.001 C 94.08157552083333 0.001 94.08157552083333 0.001 94.08157552083333 0.001 L 117.33769531249999 0.001 C 117.33769531249999 0.001 117.33769531249999 0.001 117.33769531249999 0.001 L 117.33769531249999 160.01681803385418 C 117.33769531249999 160.01681803385418 117.33769531249999 160.01681803385418 117.33769531249999 160.01681803385418 L 94.08157552083333 160.01681803385418 C 94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418 94.08157552083333 160.01681803385418 Z "
                                    pathfrom="M 94.08157552083333 160.01681803385418 L 94.08157552083333 160.01681803385418 L 117.33769531249999 160.01681803385418 L 117.33769531249999 160.01681803385418 L 117.33769531249999 160.01681803385418 L 117.33769531249999 160.01681803385418 L 117.33769531249999 160.01681803385418 L 94.08157552083333 160.01681803385418 Z"
                                    cy="0"
                                    cx="135.36542968749998"
                                    j="2"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <path
                                    id="SvgjsPath1137"
                                    d="M136.36542968749998 160.01681803385418L136.36542968749998 0.0010000000000047748C136.36542968749998 0.0010000000000047748 136.36542968749998 0.0010000000000047748 136.36542968749998 0.0010000000000047748L159.62154947916665 0.0010000000000047748C159.62154947916665 0.0010000000000047748 159.62154947916665 0.0010000000000047748 159.62154947916665 0.0010000000000047748L159.62154947916665 160.01681803385418C159.62154947916665 160.01681803385418 159.62154947916665 160.01681803385418 159.62154947916665 160.01681803385418L136.36542968749998 160.01681803385418C136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418C136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 136.36542968749998 160.01681803385418 L 136.36542968749998 0.001 C 136.36542968749998 0.001 136.36542968749998 0.001 136.36542968749998 0.001 L 159.62154947916665 0.001 C 159.62154947916665 0.001 159.62154947916665 0.001 159.62154947916665 0.001 L 159.62154947916665 160.01681803385418 C 159.62154947916665 160.01681803385418 159.62154947916665 160.01681803385418 159.62154947916665 160.01681803385418 L 136.36542968749998 160.01681803385418 C 136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418 136.36542968749998 160.01681803385418 Z "
                                    pathfrom="M 136.36542968749998 160.01681803385418 L 136.36542968749998 160.01681803385418 L 159.62154947916665 160.01681803385418 L 159.62154947916665 160.01681803385418 L 159.62154947916665 160.01681803385418 L 159.62154947916665 160.01681803385418 L 159.62154947916665 160.01681803385418 L 136.36542968749998 160.01681803385418 Z"
                                    cy="0"
                                    cx="177.64928385416664"
                                    j="3"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <path
                                    id="SvgjsPath1139"
                                    d="M178.64928385416664 160.01681803385418L178.64928385416664 0.0010000000000047748C178.64928385416664 0.0010000000000047748 178.64928385416664 0.0010000000000047748 178.64928385416664 0.0010000000000047748L201.9054036458333 0.0010000000000047748C201.9054036458333 0.0010000000000047748 201.9054036458333 0.0010000000000047748 201.9054036458333 0.0010000000000047748L201.9054036458333 160.01681803385418C201.9054036458333 160.01681803385418 201.9054036458333 160.01681803385418 201.9054036458333 160.01681803385418L178.64928385416664 160.01681803385418C178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418C178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 178.64928385416664 160.01681803385418 L 178.64928385416664 0.001 C 178.64928385416664 0.001 178.64928385416664 0.001 178.64928385416664 0.001 L 201.9054036458333 0.001 C 201.9054036458333 0.001 201.9054036458333 0.001 201.9054036458333 0.001 L 201.9054036458333 160.01681803385418 C 201.9054036458333 160.01681803385418 201.9054036458333 160.01681803385418 201.9054036458333 160.01681803385418 L 178.64928385416664 160.01681803385418 C 178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418 178.64928385416664 160.01681803385418 Z "
                                    pathfrom="M 178.64928385416664 160.01681803385418 L 178.64928385416664 160.01681803385418 L 201.9054036458333 160.01681803385418 L 201.9054036458333 160.01681803385418 L 201.9054036458333 160.01681803385418 L 201.9054036458333 160.01681803385418 L 201.9054036458333 160.01681803385418 L 178.64928385416664 160.01681803385418 Z"
                                    cy="0"
                                    cx="219.9331380208333"
                                    j="4"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <path
                                    id="SvgjsPath1141"
                                    d="M220.9331380208333 160.01681803385418L220.9331380208333 0.0010000000000047748C220.9331380208333 0.0010000000000047748 220.9331380208333 0.0010000000000047748 220.9331380208333 0.0010000000000047748L244.18925781249996 0.0010000000000047748C244.18925781249996 0.0010000000000047748 244.18925781249996 0.0010000000000047748 244.18925781249996 0.0010000000000047748L244.18925781249996 160.01681803385418C244.18925781249996 160.01681803385418 244.18925781249996 160.01681803385418 244.18925781249996 160.01681803385418L220.9331380208333 160.01681803385418C220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418C220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418 "
                                    fill="rgba(0,143,251,0.85)"
                                    fill-opacity="1"
                                    stroke-opacity="1"
                                    stroke-linecap="round"
                                    stroke-width="0"
                                    stroke-dasharray="0"
                                    class="apexcharts-bar-area undefined"
                                    index="0"
                                    clip-path="url(#gridRectBarMask1peudthz)"
                                    pathto="M 220.9331380208333 160.01681803385418 L 220.9331380208333 0.001 C 220.9331380208333 0.001 220.9331380208333 0.001 220.9331380208333 0.001 L 244.18925781249996 0.001 C 244.18925781249996 0.001 244.18925781249996 0.001 244.18925781249996 0.001 L 244.18925781249996 160.01681803385418 C 244.18925781249996 160.01681803385418 244.18925781249996 160.01681803385418 244.18925781249996 160.01681803385418 L 220.9331380208333 160.01681803385418 C 220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418 220.9331380208333 160.01681803385418 Z "
                                    pathfrom="M 220.9331380208333 160.01681803385418 L 220.9331380208333 160.01681803385418 L 244.18925781249996 160.01681803385418 L 244.18925781249996 160.01681803385418 L 244.18925781249996 160.01681803385418 L 244.18925781249996 160.01681803385418 L 244.18925781249996 160.01681803385418 L 220.9331380208333 160.01681803385418 Z"
                                    cy="0"
                                    cx="262.21699218749995"
                                    j="5"
                                    val="1"
                                    barheight="160.01581803385417"
                                    barwidth="23.256119791666666"
                                  ></path>
                                  <g
                                    id="SvgjsG1128"
                                    class="apexcharts-bar-goals-markers"
                                  >
                                    <g
                                      id="SvgjsG1130"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                    <g
                                      id="SvgjsG1132"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                    <g
                                      id="SvgjsG1134"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                    <g
                                      id="SvgjsG1136"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                    <g
                                      id="SvgjsG1138"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                    <g
                                      id="SvgjsG1140"
                                      classname="apexcharts-bar-goals-groups"
                                      class="apexcharts-hidden-element-shown"
                                      clip-path="url(#gridRectMarkerMask1peudthz)"
                                    ></g>
                                  </g>
                                  <g
                                    id="SvgjsG1129"
                                    class="apexcharts-bar-shadows apexcharts-hidden-element-shown"
                                  ></g>
                                </g>
                                <g
                                  id="SvgjsG1127"
                                  class="apexcharts-datalabels apexcharts-hidden-element-shown"
                                  data:realindex="0"
                                ></g>
                              </g>
                              <line
                                id="SvgjsLine1166"
                                x1="0"
                                y1="0"
                                x2="253.703125"
                                y2="0"
                                stroke="#b6b6b6"
                                stroke-dasharray="0"
                                stroke-width="1"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs"
                              ></line>
                              <line
                                id="SvgjsLine1167"
                                x1="0"
                                y1="0"
                                x2="253.703125"
                                y2="0"
                                stroke-dasharray="0"
                                stroke-width="0"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs-hidden"
                              ></line>
                              <g
                                id="SvgjsG1168"
                                class="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1169"
                                  class="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -10)"
                                >
                                  <text
                                    id="SvgjsText1171"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="21.141927083333332"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 22.304035186767578 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1172">Jayanth</tspan>
                                    <title>Jayanth</title>
                                  </text>
                                  <text
                                    id="SvgjsText1174"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="63.42578125"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 64.5869140625 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1175">hiran</tspan>
                                    <title>hiran</title>
                                  </text>
                                  <text
                                    id="SvgjsText1177"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="105.70963541666667"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 106.87077331542969 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1178">krishna</tspan>
                                    <title>krishna</title>
                                  </text>
                                  <text
                                    id="SvgjsText1180"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="147.99348958333331"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 149.1604766845703 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1181">prajwal</tspan>
                                    <title>prajwal</title>
                                  </text>
                                  <text
                                    id="SvgjsText1183"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="190.27734374999997"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 191.4375 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1184">raja</tspan>
                                    <title>raja</title>
                                  </text>
                                  <text
                                    id="SvgjsText1186"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="232.56119791666663"
                                    y="182.01581803385417"
                                    text-anchor="end"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="400"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-label"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    transform="rotate(-45 233.72329711914062 177.0158233642578)"
                                  >
                                    <tspan id="SvgjsTspan1187">santosh</tspan>
                                    <title>santosh</title>
                                  </text>
                                </g>
                                <g
                                  id="SvgjsG1188"
                                  class="apexcharts-xaxis-title"
                                >
                                  <text
                                    id="SvgjsText1189"
                                    font-family="Helvetica, Arial, sans-serif"
                                    x="126.8515625"
                                    y="247"
                                    text-anchor="middle"
                                    dominant-baseline="auto"
                                    font-size="12px"
                                    font-weight="900"
                                    fill="#373d3f"
                                    class="apexcharts-text apexcharts-xaxis-title-text"
                                    style="
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                  ></text>
                                </g>
                              </g>
                              <g
                                id="SvgjsG1213"
                                class="apexcharts-yaxis-annotations apexcharts-hidden-element-shown"
                              ></g>
                              <g
                                id="SvgjsG1214"
                                class="apexcharts-xaxis-annotations apexcharts-hidden-element-shown"
                              ></g>
                              <g
                                id="SvgjsG1215"
                                class="apexcharts-point-annotations apexcharts-hidden-element-shown"
                              ></g>
                            </g>
                          </svg>
                          <div
                            class="apexcharts-tooltip apexcharts-theme-light"
                          >
                            <div
                              class="apexcharts-tooltip-title"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                font-size: 12px;
                              "
                            ></div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-0"
                              style="order: 1"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(0, 143, 251)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light"
                          >
                            <div class="apexcharts-yaxistooltip-text"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="z-rv-chart"
                      style="
                        height: 360px;
                        left: 480px;
                        position: absolute;
                        top: 64px;
                        width: 348px;
                      "
                    >
                      <div
                        options="[object Object]"
                        series="1,1,1,1,1,1"
                        type="pie"
                        height="100%"
                        width="100%"
                      >
                        <div
                          id="apexchartspzsnl8bh"
                          class="apexcharts-canvas apexchartspzsnl8bh apexcharts-theme-"
                          style="width: 306px; height: 318px"
                        >
                          <svg
                            id="SvgjsSvg1216"
                            width="306"
                            height="318"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.dev"
                            class="apexcharts-svg"
                            xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                          >
                            <foreignObject x="0" y="0" width="306" height="318">
                              <div
                                class="apexcharts-legend apexcharts-align-center apx-legend-position-bottom"
                                xmlns="http://www.w3.org/1999/xhtml"
                                style="
                                  right: 0px;
                                  position: absolute;
                                  left: 0px;
                                  top: 269px;
                                  max-height: 159px;
                                "
                              >
                                <div
                                  class="apexcharts-legend-series"
                                  rel="1"
                                  seriesname="Jayanth"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="1"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1221"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1222"
                                        ><clipPath id="gridRectMaskpzsnl8bh"
                                          ><rect
                                            id="SvgjsRect1239"
                                            width="306"
                                            height="231"
                                            x="0"
                                            y="0"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath id="gridRectBarMaskpzsnl8bh"
                                          ><rect
                                            id="SvgjsRect1240"
                                            width="312"
                                            height="237"
                                            x="-3"
                                            y="-3"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="gridRectMarkerMaskpzsnl8bh"
                                          ><rect
                                            id="SvgjsRect1241"
                                            width="322"
                                            height="247"
                                            x="-8"
                                            y="-8"
                                            rx="0"
                                            ry="0"
                                            opacity="1"
                                            stroke-width="0"
                                            stroke="none"
                                            stroke-dasharray="0"
                                            fill="#fff"
                                          ></rect></clipPath
                                        ><clipPath
                                          id="forecastMaskpzsnl8bh"
                                        ></clipPath
                                        ><clipPath
                                          id="nonForecastMaskpzsnl8bh"
                                        ></clipPath></defs
                                      ><path
                                        id="SvgjsPath1223"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#008ffb"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="1"
                                    i="0"
                                    data:default-text="Jayanth"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >Jayanth</span
                                  >
                                </div>
                                <div
                                  class="apexcharts-legend-series"
                                  rel="2"
                                  seriesname="hiran"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="2"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1224"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1225"></defs
                                      ><path
                                        id="SvgjsPath1226"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#00e396"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="2"
                                    i="1"
                                    data:default-text="hiran"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >hiran</span
                                  >
                                </div>
                                <div
                                  class="apexcharts-legend-series"
                                  rel="3"
                                  seriesname="krishna"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="3"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1227"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1228"></defs
                                      ><path
                                        id="SvgjsPath1229"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#feb019"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="3"
                                    i="2"
                                    data:default-text="krishna"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >krishna</span
                                  >
                                </div>
                                <div
                                  class="apexcharts-legend-series"
                                  rel="4"
                                  seriesname="prajwal"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="4"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1230"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1231"></defs
                                      ><path
                                        id="SvgjsPath1232"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#ff4560"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="4"
                                    i="3"
                                    data:default-text="prajwal"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >prajwal</span
                                  >
                                </div>
                                <div
                                  class="apexcharts-legend-series"
                                  rel="5"
                                  seriesname="rajax"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="5"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1233"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1234"></defs
                                      ><path
                                        id="SvgjsPath1235"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#775dd0"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="5"
                                    i="4"
                                    data:default-text="raja%20"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >raja
                                  </span>
                                </div>
                                <div
                                  class="apexcharts-legend-series"
                                  rel="6"
                                  seriesname="santosh"
                                  data:collapsed="false"
                                  style="margin: 4px 5px"
                                >
                                  <span
                                    class="apexcharts-legend-marker"
                                    rel="6"
                                    data:collapsed="false"
                                    style="
                                      height: 16px;
                                      width: 16px;
                                      left: 0px;
                                      top: 0px;
                                    "
                                    ><svg
                                      id="SvgjsSvg1236"
                                      width="100%"
                                      height="100%"
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.1"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xmlns:svgjs="http://svgjs.dev"
                                      ><defs id="SvgjsDefs1237"></defs
                                      ><path
                                        id="SvgjsPath1238"
                                        d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                                        fill="#4caf50"
                                        fill-opacity="1"
                                        stroke="#ffffff"
                                        stroke-opacity="0.9"
                                        stroke-linecap="butt"
                                        stroke-width="1"
                                        stroke-dasharray="0"
                                        cx="0"
                                        cy="0"
                                        shape="circle"
                                        class="apexcharts-legend-marker apexcharts-marker apexcharts-marker-circle"
                                        style="transform: translate(50%, 50%)"
                                      ></path></svg
                                  ></span>
                                  <span
                                    class="apexcharts-legend-text"
                                    rel="6"
                                    i="5"
                                    data:default-text="santosh"
                                    data:collapsed="false"
                                    style="
                                      color: rgb(55, 61, 63);
                                      font-size: 12px;
                                      font-weight: 400;
                                      font-family: Helvetica, Arial, sans-serif;
                                    "
                                    >santosh</span
                                  >
                                </div>
                              </div>
                              <style type="text/css">
                                .apexcharts-flip-y {
                                  transform: scaleY(-1) translateY(-100%);
                                  transform-origin: top;
                                  transform-box: fill-box;
                                }
                                .apexcharts-flip-x {
                                  transform: scaleX(-1);
                                  transform-origin: center;
                                  transform-box: fill-box;
                                }
                                .apexcharts-legend {
                                  display: flex;
                                  overflow: auto;
                                  padding: 0 10px;
                                }
                                .apexcharts-legend.apx-legend-position-bottom,
                                .apexcharts-legend.apx-legend-position-top {
                                  flex-wrap: wrap;
                                }
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  flex-direction: column;
                                  bottom: 0;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-left,
                                .apexcharts-legend.apx-legend-position-right,
                                .apexcharts-legend.apx-legend-position-left {
                                  justify-content: flex-start;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
                                  justify-content: center;
                                }
                                .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right,
                                .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
                                  justify-content: flex-end;
                                }
                                .apexcharts-legend-series {
                                  cursor: pointer;
                                  line-height: normal;
                                  display: flex;
                                  align-items: center;
                                }
                                .apexcharts-legend-text {
                                  position: relative;
                                  font-size: 14px;
                                }
                                .apexcharts-legend-text *,
                                .apexcharts-legend-marker * {
                                  pointer-events: none;
                                }
                                .apexcharts-legend-marker {
                                  position: relative;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  cursor: pointer;
                                  margin-right: 1px;
                                }

                                .apexcharts-legend-series.apexcharts-no-click {
                                  cursor: auto;
                                }
                                .apexcharts-legend
                                  .apexcharts-hidden-zero-series,
                                .apexcharts-legend
                                  .apexcharts-hidden-null-series {
                                  display: none !important;
                                }
                                .apexcharts-inactive-legend {
                                  opacity: 0.45;
                                }
                              </style>
                            </foreignObject>
                            <g
                              id="SvgjsG1218"
                              class="apexcharts-inner apexcharts-graphical"
                              transform="translate(0, 29)"
                            >
                              <defs id="SvgjsDefs1217"></defs>
                              <g id="SvgjsG1244" class="apexcharts-pie">
                                <g
                                  id="SvgjsG1245"
                                  transform="translate(0, 0) scale(1)"
                                >
                                  <g id="SvgjsG1246" class="apexcharts-slices">
                                    <g
                                      id="SvgjsG1247"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="Jayanth"
                                      rel="1"
                                      data:realindex="0"
                                    >
                                      <path
                                        id="SvgjsPath1248"
                                        d="M 153 8.817073170731703 A 106.6829268292683 106.6829268292683 0 0 1 245.3901247842228 62.15853658536586 L 156.46410161513776 113.5 C 154.7320508075689 114.5 153 113.5 153 111.5 L 153 8.817073170731703 "
                                        fill="rgba(0,143,251,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-0"
                                        index="0"
                                        j="0"
                                        data:angle="60"
                                        data:startangle="0"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 153 8.817073170731703 A 106.6829268292683 106.6829268292683 0 0 1 245.3901247842228 62.15853658536586 L 156.46410161513776 113.5 C 154.7320508075689 114.5 153 113.5 153 111.5 L 153 8.817073170731703 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1249"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="hiran"
                                      rel="2"
                                      data:realindex="1"
                                    >
                                      <path
                                        id="SvgjsPath1250"
                                        d="M 245.3901247842228 62.15853658536586 A 106.6829268292683 106.6829268292683 0 0 1 245.3901247842228 168.84146341463415 L 156.46410161513776 117.5 C 154.7320508075689 116.5 154.7320508075689 114.5 156.46410161513776 113.5 L 245.3901247842228 62.15853658536586 "
                                        fill="rgba(0,227,150,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-1"
                                        index="0"
                                        j="1"
                                        data:angle="60"
                                        data:startangle="60"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 245.3901247842228 62.15853658536586 A 106.6829268292683 106.6829268292683 0 0 1 245.3901247842228 168.84146341463415 L 156.46410161513776 117.5 C 154.7320508075689 116.5 154.7320508075689 114.5 156.46410161513776 113.5 L 245.3901247842228 62.15853658536586 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1251"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="krishna"
                                      rel="3"
                                      data:realindex="2"
                                    >
                                      <path
                                        id="SvgjsPath1252"
                                        d="M 245.3901247842228 168.84146341463415 A 106.6829268292683 106.6829268292683 0 0 1 153 222.1829268292683 L 153 119.5 C 153 117.5 154.7320508075689 116.5 156.46410161513776 117.5 L 245.3901247842228 168.84146341463415 "
                                        fill="rgba(254,176,25,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-2"
                                        index="0"
                                        j="2"
                                        data:angle="60"
                                        data:startangle="120"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 245.3901247842228 168.84146341463415 A 106.6829268292683 106.6829268292683 0 0 1 153 222.1829268292683 L 153 119.5 C 153 117.5 154.7320508075689 116.5 156.46410161513776 117.5 L 245.3901247842228 168.84146341463415 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1253"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="prajwal"
                                      rel="4"
                                      data:realindex="3"
                                    >
                                      <path
                                        id="SvgjsPath1254"
                                        d="M 153 222.1829268292683 A 106.6829268292683 106.6829268292683 0 0 1 60.609875215777194 168.84146341463415 L 149.53589838486224 117.5 C 151.2679491924311 116.5 153 117.5 153 119.5 L 153 222.1829268292683 "
                                        fill="rgba(255,69,96,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-3"
                                        index="0"
                                        j="3"
                                        data:angle="60"
                                        data:startangle="180"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 153 222.1829268292683 A 106.6829268292683 106.6829268292683 0 0 1 60.609875215777194 168.84146341463415 L 149.53589838486224 117.5 C 151.2679491924311 116.5 153 117.5 153 119.5 L 153 222.1829268292683 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1255"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="rajax"
                                      rel="5"
                                      data:realindex="4"
                                    >
                                      <path
                                        id="SvgjsPath1256"
                                        d="M 60.609875215777194 168.84146341463415 A 106.6829268292683 106.6829268292683 0 0 1 60.60987521577721 62.15853658536584 L 149.53589838486224 113.5 C 151.2679491924311 114.5 151.2679491924311 116.5 149.53589838486224 117.5 L 60.609875215777194 168.84146341463415 "
                                        fill="rgba(119,93,208,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-4"
                                        index="0"
                                        j="4"
                                        data:angle="60"
                                        data:startangle="240"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 60.609875215777194 168.84146341463415 A 106.6829268292683 106.6829268292683 0 0 1 60.60987521577721 62.15853658536584 L 149.53589838486224 113.5 C 151.2679491924311 114.5 151.2679491924311 116.5 149.53589838486224 117.5 L 60.609875215777194 168.84146341463415 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                    <g
                                      id="SvgjsG1257"
                                      class="apexcharts-series apexcharts-pie-series"
                                      seriesname="santosh"
                                      rel="6"
                                      data:realindex="5"
                                    >
                                      <path
                                        id="SvgjsPath1258"
                                        d="M 60.60987521577721 62.15853658536584 A 106.6829268292683 106.6829268292683 0 0 1 152.98138031680617 8.817074795605592 L 152.99930186830275 111.50000006092348 C 152.99965093415136 113.50000003046173 151.2679491924311 114.5 149.53589838486224 113.5 L 60.60987521577721 62.15853658536584 "
                                        fill="rgba(76,175,80,1)"
                                        fill-opacity="1"
                                        stroke-opacity="1"
                                        stroke-linecap="butt"
                                        stroke-width="2"
                                        stroke-dasharray="0"
                                        class="apexcharts-pie-area apexcharts-pie-slice-5"
                                        index="0"
                                        j="5"
                                        data:angle="60"
                                        data:startangle="300"
                                        data:strokewidth="2"
                                        data:value="1"
                                        data:pathorig="M 60.60987521577721 62.15853658536584 A 106.6829268292683 106.6829268292683 0 0 1 152.98138031680617 8.817074795605592 L 152.99930186830275 111.50000006092348 C 152.99965093415136 113.50000003046173 151.2679491924311 114.5 149.53589838486224 113.5 L 60.60987521577721 62.15853658536584 "
                                        stroke="#ffffff"
                                      ></path>
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <line
                                id="SvgjsLine1259"
                                x1="0"
                                y1="0"
                                x2="306"
                                y2="0"
                                stroke="#b6b6b6"
                                stroke-dasharray="0"
                                stroke-width="1"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs"
                              ></line>
                              <line
                                id="SvgjsLine1260"
                                x1="0"
                                y1="0"
                                x2="306"
                                y2="0"
                                stroke-dasharray="0"
                                stroke-width="0"
                                stroke-linecap="butt"
                                class="apexcharts-ycrosshairs-hidden"
                              ></line>
                            </g>
                            <text
                              id="SvgjsText1219"
                              font-family="Helvetica, Arial, sans-serif"
                              x="153"
                              y="16.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="14px"
                              font-weight="900"
                              fill="#373d3f"
                              class="apexcharts-title-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            >
                              New Chart
                            </text>
                            <text
                              id="SvgjsText1220"
                              font-family="Helvetica, Arial, sans-serif"
                              x="153"
                              y="44.5"
                              text-anchor="middle"
                              dominant-baseline="auto"
                              font-size="12px"
                              font-weight="400"
                              fill="#373d3f"
                              class="apexcharts-subtitle-text"
                              style="
                                font-family: Helvetica, Arial, sans-serif;
                                opacity: 1;
                              "
                            ></text>
                            <g
                              id="SvgjsG1242"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                            <g
                              id="SvgjsG1243"
                              class="apexcharts-datalabels-group"
                              transform="translate(0, 0) scale(1)"
                            ></g>
                          </svg>
                          <div class="apexcharts-tooltip apexcharts-theme-dark">
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-0"
                              style="order: 1"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(0, 143, 251)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-1"
                              style="order: 2"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(0, 227, 150)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-2"
                              style="order: 3"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(254, 176, 25)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-3"
                              style="order: 4"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(255, 69, 96)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-4"
                              style="order: 5"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(119, 93, 208)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div
                              class="apexcharts-tooltip-series-group apexcharts-tooltip-series-group-5"
                              style="order: 6"
                            >
                              <span
                                class="apexcharts-tooltip-marker"
                                style="background-color: rgb(76, 175, 80)"
                              ></span>
                              <div
                                class="apexcharts-tooltip-text"
                                style="
                                  font-family: Helvetica, Arial, sans-serif;
                                  font-size: 12px;
                                "
                              >
                                <div class="apexcharts-tooltip-y-group">
                                  <span
                                    class="apexcharts-tooltip-text-y-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-y-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-goals-group">
                                  <span
                                    class="apexcharts-tooltip-text-goals-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-goals-value"
                                  ></span>
                                </div>
                                <div class="apexcharts-tooltip-z-group">
                                  <span
                                    class="apexcharts-tooltip-text-z-label"
                                  ></span
                                  ><span
                                    class="apexcharts-tooltip-text-z-value"
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="z-default-text d_flex align_center gap_2 z-text-primary-400 z-font-xl z-font-weight-large"
                      style="
                        height: 32px;
                        left: 40px;
                        position: absolute;
                        top: 20px;
                        width: 240px;
                      "
                    >
                      <span>Table With Chart</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="section"
                style="height: 576px; position: relative; min-height: 1370px"
              >
                <div
                  class="block-recordsview"
                  style="
                    height: 528px;
                    left: 36px;
                    position: absolute;
                    top: 48px;
                    width: 1512px;
                    min-height: 1322px;
                  "
                >
                  <div
                    class="section"
                    style="
                      height: 1308px;
                      position: relative;
                      min-height: 1322px;
                    "
                  >
                    <div
                      class="rv-block z-img-cover"
                      style="
                        height: 132px;
                        left: 24px;
                        position: absolute;
                        top: 60px;
                        width: 228px;
                      "
                    >
                      <div
                        class="z-font-lg z-font-weight-extra"
                        id=""
                        style="
                          height: 24px;
                          left: 168px;
                          position: absolute;
                          top: 24px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 24px;
                          position: absolute;
                          top: 24px;
                          width: 120px;
                        "
                      >
                        <span>Total Count</span>
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 22px;
                          position: absolute;
                          top: 70px;
                          width: 96px;
                        "
                      >
                        <span>Amount</span>
                      </div>
                      <div
                        class=" "
                        id=""
                        style="
                          height: 24px;
                          left: 156px;
                          position: absolute;
                          top: 72px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                    </div>
                    <div
                      class="rv-block z-img-cover z-shadow-sm z-border-radius-sm"
                      style="
                        height: 132px;
                        left: 336px;
                        position: absolute;
                        top: 60px;
                        width: 228px;
                      "
                    >
                      <div
                        class="z-font-lg z-font-weight-extra"
                        id=""
                        style="
                          height: 24px;
                          left: 168px;
                          position: absolute;
                          top: 24px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 24px;
                          position: absolute;
                          top: 24px;
                          width: 120px;
                        "
                      >
                        <span>Total Count</span>
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 22px;
                          position: absolute;
                          top: 70px;
                          width: 96px;
                        "
                      >
                        <span>Amount</span>
                      </div>
                      <div
                        class=" "
                        id=""
                        style="
                          height: 24px;
                          left: 156px;
                          position: absolute;
                          top: 72px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                    </div>
                    <div
                      class="rv-block z-img-cover z-border-radius-md z-shadow-md"
                      style="
                        height: 132px;
                        left: 648px;
                        position: absolute;
                        top: 60px;
                        width: 228px;
                      "
                    >
                      <div
                        class="z-font-lg z-font-weight-extra"
                        id=""
                        style="
                          height: 24px;
                          left: 168px;
                          position: absolute;
                          top: 24px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 24px;
                          position: absolute;
                          top: 24px;
                          width: 120px;
                        "
                      >
                        <span>Total Count</span>
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 22px;
                          position: absolute;
                          top: 70px;
                          width: 96px;
                        "
                      >
                        <span>Amount</span>
                      </div>
                      <div
                        class=" "
                        id=""
                        style="
                          height: 24px;
                          left: 156px;
                          position: absolute;
                          top: 72px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                    </div>
                    <div
                      class="rv-block z-img-cover z-border-radius-lg z-shadow-lg"
                      style="
                        height: 132px;
                        left: 960px;
                        position: absolute;
                        top: 60px;
                        width: 228px;
                      "
                    >
                      <div
                        class="z-font-lg z-font-weight-extra"
                        id=""
                        style="
                          height: 24px;
                          left: 168px;
                          position: absolute;
                          top: 24px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 24px;
                          position: absolute;
                          top: 24px;
                          width: 120px;
                        "
                      >
                        <span>Total Count</span>
                      </div>
                      <div
                        class="z-default-text d_flex align_center gap_2 z-font-weight-large z-font-md"
                        style="
                          height: 24px;
                          left: 22px;
                          position: absolute;
                          top: 70px;
                          width: 96px;
                        "
                      >
                        <span>Amount</span>
                      </div>
                      <div
                        class=" "
                        id=""
                        style="
                          height: 24px;
                          left: 156px;
                          position: absolute;
                          top: 72px;
                          width: 36px;
                        "
                      >
                        15
                      </div>
                    </div>
                    <div
                      class="rv-container"
                      style="
                        height: 1074px;
                        left: 24px;
                        position: absolute;
                        top: 248px;
                        width: 1548px;
                      "
                    >
                      <div class="rv-table-wrap">
                        <table class="recordview_table">
                          <thead>
                            <tr>
                              <th align="left">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>custom</span>
                                </div>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Poduct Name</span>
                                </div>
                              </th>
                              <th align="left" class="" style="width: auto">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>Payment</span>
                                </div>
                              </th>
                              <th align="left">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>custom</span>
                                </div>
                              </th>
                              <th align="left">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                    cursor: pointer;
                                  "
                                >
                                  <span>custom</span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-4187816355.jpg?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >70010</span
                                    >
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">Nike</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Nike</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>70010</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-1358138276.png?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >44440400</span
                                    >
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">Polo</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Polo</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>44440400</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-9857713810.png?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit">7777</span>
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">Kids</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Kids</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>7777</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 86px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-3227508181.jpg?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >10000</span
                                    >
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">Nike</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Nike</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>10000</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 86px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-9088177355.jpg?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >20000</span
                                    >
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">Polo</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Polo</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>20000</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-3758814058.jpg?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"></span>
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit"></span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span></span
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span></span
                                ></span>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 86px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  >
                                    <img
                                      class="image-field"
                                      src="https://sandbox.getzino.site/679c55f0442a50c11669da51/api/v1/assets/fileName/upload-7319057888.jpg?original=true"
                                      alt="[object Object]"
                                    />
                                  </div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"></span>
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit"></span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span></span
                                ></span>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span></span
                                ></span>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  ></div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit">7777</span>
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">car</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>car</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>7777</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  ></div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >10000</span
                                    >
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit">car</span>
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>car</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>10000</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="">
                              <td align="left" style="max-width: 400px">
                                <div class="section" style="height: 72px">
                                  <div
                                    class=""
                                    id=""
                                    style="
                                      height: auto;
                                      left: 0px;
                                      position: absolute;
                                      top: 0px;
                                      width: 80px;
                                    "
                                  ></div>
                                  <div
                                    class="z-font-lg z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 42px;
                                      left: 114px;
                                      position: absolute;
                                      top: 30px;
                                      width: 240px;
                                    "
                                  >
                                    <span style="font-size: inherit">777</span>
                                  </div>
                                  <div
                                    class="z-font-md z-font-weight-large d_flex gap_2 z-default-text"
                                    style="
                                      height: 30px;
                                      left: 114px;
                                      position: absolute;
                                      top: 6px;
                                      width: 234px;
                                    "
                                  >
                                    <span style="font-size: inherit"
                                      >Boots</span
                                    >
                                  </div>
                                </div>
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>Boots</span></span
                                >
                              </td>
                              <td align="left" style="width: auto">
                                <span class="tableContext_data"
                                  ><span>777</span></span
                                >
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <button
                                    class="z-btn-outline element-button z-btn-primary z-btn"
                                  >
                                    360
                                  </button>
                                </div>
                              </td>
                              <td style="width: auto">
                                <div class="d_flex gap_3">
                                  <div
                                    class="z-dropdown-container element-dropdown z-btn-outline field_page_dropdown"
                                    id="undefined"
                                    style="padding: 0px"
                                  >
                                    <div
                                      class="z-dropdown-selected-item-wrapper element-dropdown-field"
                                      style="border: none"
                                    >
                                      <span class="dropdown-selected-item"
                                        >Dropdown</span
                                      ><span class="material-symbols-outlined"
                                        >keyboard_arrow_down</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="z-rv-footer">
                        <div class="gap_3">
                          <div
                            class="recordview_filter_dropDown_outerBox w_fit"
                            style="padding: 8px; min-width: 0px"
                          >
                            <span class="recordview_filter_field_exp"
                              ><span>10</span>
                              <svg
                                class="expand_arrow_icon"
                                width="16px"
                                height="16px"
                                fill="#fff"
                                version="1.1"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.285,11.284L16,19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429,0  c-0.394,0.395-0.394,1.035,0,1.43l8.999,9.002l0,0l0,0c0.394,0.395,1.034,0.395,1.428,0l8.999-9.002  c0.394-0.395,0.394-1.036,0-1.431C25.319,10.889,24.679,10.889,24.285,11.284z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <p class="app_label">1-10 of 15</p>
                        </div>
                        <div class="gap_3">
                          <button class="zino_btn_disabled arrow_btn">
                            <svg
                              width="20px"
                              height="20px"
                              viewBox="0 0 32 32"
                              fill="#667085"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                clip-rule="evenodd"
                                d="M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z"
                              ></path>
                            </svg>
                          </button>
                          <div
                            class="recordview_filter_dropDown_outerBox"
                            style="padding: 8px; min-width: 0px"
                          >
                            <span class="recordview_filter_field_exp"
                              ><span>1</span>
                              <svg
                                class="expand_arrow_icon"
                                width="16px"
                                height="16px"
                                fill="#fff"
                                version="1.1"
                                viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.285,11.284L16,19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429,0  c-0.394,0.395-0.394,1.035,0,1.43l8.999,9.002l0,0l0,0c0.394,0.395,1.034,0.395,1.428,0l8.999-9.002  c0.394-0.395,0.394-1.036,0-1.431C25.319,10.889,24.679,10.889,24.285,11.284z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                          <button class="zino_btn_outline_secondary arrow_btn">
                            <svg
                              width="20px"
                              height="20px"
                              viewBox="0 0 32 32"
                              fill="#667085"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                clip-rule="evenodd"
                                d="M21.698,15.286l-9.002-8.999  c-0.395-0.394-1.035-0.394-1.431,0c-0.395,0.394-0.395,1.034,0,1.428L19.553,16l-8.287,8.285c-0.395,0.394-0.395,1.034,0,1.429  c0.395,0.394,1.036,0.394,1.431,0l9.002-8.999C22.088,16.325,22.088,15.675,21.698,15.286z"
                                fill-rule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="z-default-text d_flex align_center gap_2 z-text-primary-400 z-font-xl z-font-weight-large"
                      style="
                        height: 32px;
                        left: 28px;
                        position: absolute;
                        top: 12px;
                        width: 256px;
                      "
                    >
                      <span>Table With Tile</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            position: fixed;
            z-index: 9999;
            inset: 16px;
            pointer-events: none;
          "
        ></div>
      </div>
    </div>
    <div id="maproot"></div>
    <div id="load_extra_js">
      <script type="text/javascript" defer=""></script>
    </div>
    <div id="checkoutroot"></div>

    <script
      src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"
      crossorigin=""
    ></script>
    <script
      src="https://cdn.jsdelivr.net/npm/react-dom/umd/react-dom.production.min.js"
      crossorigin=""
    ></script>

    <!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.25/jspdf.plugin.autotable.min.js"></script> -->

    <svg
      id="SvgjsSvg1001"
      width="2"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.dev"
      style="
        overflow: hidden;
        top: -100%;
        left: -100%;
        position: absolute;
        opacity: 0;
      "
    >
      <defs id="SvgjsDefs1002"></defs>
      <polyline id="SvgjsPolyline1003" points="0,0"></polyline>
      <path id="SvgjsPath1004" d="M0 0 "></path>
    </svg>
    <script src="/file/jspdf.umd.min.js" async="true"></script>
    <script src="/file/jspdf.plugin.autotable.min.js" async="true"></script>
    <script src="/file/quill.js" async="true"></script>
  </body>
</html>
`;
